import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CartActions, MultiCartState } from '@spartacus/cart/base/core';
import { filter, map } from 'rxjs/operators';

import { KnBrQuoteContextService } from '../../../../saved-carts/core/facade/kn-br-quote-context.service';
import { KnBrCartContextAdapter } from '../../connectors/kn-br-cart-context.adapter';
import {
  KnBrCartAddUpdateContext,
  KnBrCartContextActions,
  KnBrCartContextActionTypes,
  KnBrCartLoadSuccessContext,
  KnBrCartRemoveContext,
  KnBrCartResetContext,
} from '../actions/kn-br-cart-context.actions';

@Injectable()
export class KnBrCartContextEffects {
  // @Effect()
  loadCartContext$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KnBrCartContextActionTypes.KnBrCartContextLoadAction),
      map(() => {
        const context = this.knBrCartContextAdapter.get();
        return new KnBrCartLoadSuccessContext(context);
      })
    )
  );
  // @Effect({ dispatch: false })
  addUpdateCartContext$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(KnBrCartContextActionTypes.KnBrCartContextAddUpdateAction),
        map((action: KnBrCartAddUpdateContext) => action.payload),
        map((cartCode: string) => {
          this.knBrQuoteContextService.delete();
          this.store.dispatch(new CartActions.SetActiveCartId(cartCode));
          this.knBrCartContextAdapter.set(cartCode);
        })
      ),
    { dispatch: false }
  );
  //@Effect({ dispatch: false })
  removeCartContext$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(KnBrCartContextActionTypes.KnBrCartContextRemoveAction),
        map((action: KnBrCartRemoveContext) => action.payload),
        map(() => {
          this.store.dispatch(new CartActions.ClearCartState());
          this.knBrCartContextAdapter.remove();
        })
      ),
    { dispatch: false }
  );
  //@Effect({ dispatch: false })
  resetCartContext$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(KnBrCartContextActionTypes.KnBrCartContextResetAction),
        map((action: KnBrCartResetContext) => action.payload),
        map(() => {
          this.knBrCartContextAdapter.remove();
        })
      ),
    { dispatch: false }
  );

  removeStaleCartContext$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CartActions.REMOVE_CART, CartActions.LOAD_CART_FAIL, CartActions.CART_ADD_ENTRY_FAIL),
      map(
        (action: CartActions.RemoveCart | CartActions.LoadCartFail | CartActions.CartAddEntryFail) =>
          action.payload?.cartId
      ),
      filter((cartId) => !!cartId && cartId === this.knBrCartContextAdapter.get()),
      map(() => new KnBrCartRemoveContext())
    )
  );

  constructor(
    private actions$: Actions<KnBrCartContextActions>,
    private knBrCartContextAdapter: KnBrCartContextAdapter,
    private store: Store<MultiCartState>,
    private knBrQuoteContextService: KnBrQuoteContextService
  ) {}
}
